"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CtaSobre() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="sobre-cta" id="cta-sobre" className="relative bg-background text-foreground py-32 md:py-40 overflow-hidden border-t border-border/30">
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: "url(https://fulcro.mx/wp-content/uploads/2026/04/fulcro-textura-fulcrums-dark.svg)",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      opacity: 0.15
    }} aria-hidden="true" />

      <div ref={ref} className={`relative z-10 max-w-3xl mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal text-foreground leading-tight mb-8">
          Hablemos.
        </h2>

        <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed mb-12 max-w-2xl mx-auto">
          Una llamada de 30 minutos para entender tu operación. Si hay fit, seguimos. Si no, te queda claridad sobre el siguiente paso.
        </p>

        <Button asChild size="lg" className="h-14 px-8 text-base font-medium bg-primary hover:bg-primary/90 text-primary-foreground rounded-sm transition-colors">
          <Link to="https://fulcro.mx/contacto/">
            Agendar 30 minutos
            <ArrowRight className="ml-2 size-5" />
          </Link>
        </Button>
      </div>
    </section>;
}